import { EventDataContext } from "@components/context/EventDataContext";
import { useContext, useEffect, useRef, useState } from "react";
import style from "../styles/pujaDetails.module.css";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { Typography, useMediaQuery } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import useCollapse from "react-collapsed";
import ReactHtmlParser from "html-react-parser";
import html2plaintext from "html2plaintext";
import { CONTACT_NUMBER, PANDIT_AVAILABILITY, SMS_TEMPLATE, WEB_ENGAGE } from "@utils/constants";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { trackEvent } from "@utils/analytics/event-analytics";
import theme from "src/globalModule/styles/theme";
import HeadingPuja from "../components/pujaDetailsComponents/HeadingPuja";
import { Store } from "@utils/store/ContextStore";
import BenefitsPuja from "../components/pujaDetailsComponents/BenefitsPuja";
// import EventYoutubeVideo from "../components/pujaDetailsComponents/EventYoutubeVideo";
//import EventReviews from "../components/pujaDetailsComponents/EventReviews";
import FaqPuja from "../components/pujaDetailsComponents/FaqPuja";
import { appBaseUrl } from "@utils/BASE-URL";
import PujaRegisterButton from "../components/pujaDetailsComponents/PujaRegisterButton";
import dynamic from "next/dynamic";
import Cookies from "js-cookie";
import { setEventData } from "@utils/reduxToolkit/features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import HeaderPujaDetailsAB from "../components/pujaDetailsComponents/ABTesting/HeaderPujaDetails";
import PujaStep from "../components/pujaDetailsComponents/ABTesting/PujaStep";
import ScrollNavbarAB from "../components/pujaDetailsComponents/ABTesting/ScrollNav";
import PujaCategoryListAB from "../components/pujaDetailsComponents/ABTesting/PujaCategoryList";
import TalkToPanditModal from "../components/pujaDetailsComponents/talkToPanditModal";
import PopupModal from "../components/pujaDetailsComponents/popupModal";
import panditBanner from "../../../public/assets/newEvent/pujaDetails/expertPanditBanner.webp";
import Image from "next/legacy/image";
import RegistrationLogin from "../components/pujaRegistration/modal/login";
import RegistrationBhet from "../components/pujaRegistration/modal/bhet";
import { updatePujaAmount } from "@utils/reduxToolkit/features/cartSlice";
import { eventRegistration } from "../queries/pujas.queries";
import { addRegistrationDetails } from "@utils/reduxToolkit/features/registrationDetailsSlice";
import { useCookies } from "react-cookie";
const PujaReviews = dynamic(() => import("../components/pujaDetailsComponents/PujaReviews"));
// const PujaYoutubeVideo = dynamic(() =>
//   import("../components/pujaDetailsComponents/PujaYoutubeVideo")
// );
import PujaYoutubeVideo from "../components/pujaDetailsComponents/PujaYoutubeVideo";
function PujaDetailsAB() {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const {
    data
  } = useContext(EventDataContext); // Event data
  // const { data } = useContext({}); // Event data

  // State to control which components are rendered
  // const [showSecondBatch, setShowSecondBatch] = useState(false);

  const dispatch = useDispatch();
  const [activeLink, setActiveLink] = useState("about");
  const [showMoreBtn, setShowMoreBtn] = useState(false);
  const [seeMore, setSeeMore] = useState(false);
  const bigScreen = useMediaQuery("(min-width:768px)");
  const {
    state
  } = useContext(Store);
  const user = state.user;
  // console.log("user", user);

  const [supportWhatsappUrl, setSupportWhatsappUrl] = useState("");
  const [visibleBookBtn, setVisibleBookBtn] = useState(true);
  // const [prevScrollY, setPrevScrollY] = useState(0);

  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [sampleYoutube, setSampleYoutube] = useState("");
  const [openTalkToPanditModal, setOpenTalkToPanditModal] = useState(false);
  const [openPopupModal, setOpenPopupModal] = useState(false);
  const [dontShowPopup, setDontShowPopup] = useState(false);

  /** Registration Modal */
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showBhetModal, setShowBhetModal] = useState(false);
  const [userCookieObj, setUserCookieObj] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["seatNo"]);
  const refs = {
    sevas: useRef(null),
    benefits: useRef(null),
    about: useRef(null),
    process: useRef(null),
    youtubeVideo: useRef(null),
    review: useRef(null),
    faq: useRef(null)
  };
  useEffect(() => {
    const generateRandomSeatNo = () => {
      if (!cookies.seatNo || parseInt(cookies.seatNo) === 0) {
        const randomSeatNo = Math.floor(Math.random() * (30 - 4 + 1)) + 4;
        setCookie("seatNo", randomSeatNo, {
          path: "/",
          maxAge: 60 * 60
        });
      }
    };
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data?.name_WE || "Unknown Kriya",
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: data?.urlExtension
    });
    generateRandomSeatNo();
    // Load second batch of components after 3 seconds
    // const timer = setTimeout(() => {
    //   // setShowFirstBatch(false);
    //   setShowSecondBatch(true);
    // }, 1000); // Adjust delay (1000ms = 1 seconds)

    // // Cleanup the timeout if the component is unmounted
    // return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (data) {
      let tempImageArray = [];
      data.images.map(image => {
        tempImageArray.push(image);
      });
      let description = "";
      if (data.CommunityEventAbouts?.length > 0) {
        let result = data.CommunityEventAbouts[0].text.replace(/style="height: \d+px;width: \d+px"/g, `style="height: auto; width: 100%; object-fit: contain;"`);
        result = result.replace(/style="height: auto;width: auto"/g, `style="height: auto; width: 100%; object-fit: contain;"`);
        description = html2plaintext(result);
        if (bigScreen ? description.length > 1000 : description.length > 100) {
          setShowMoreBtn(true);
        }
      } else if (data.description) {
        description = data.description;
        if (bigScreen ? description.length > 1000 : description.length > 100) {
          setShowMoreBtn(true);
        }
      }
      let eventUrl = "";
      if (data.urlExtension && data.EventDeityTypes[0]?.DeityType) {
        eventUrl = `${appBaseUrl}/${router.locale}/puja/${data.EventDeityTypes[0]?.DeityType.name}/${data.urlExtension}?utm_source=cx`;
      } else {
        eventUrl = `${appBaseUrl}/${router.locale}/puja/${data.urlExtension}?utm_source=cx`;
      }
      let supportMsg = `Namaste Utsav Admin🙏\u2029\u2029Help me register in:\u2029*${data.name}*\u2029\u2029${eventUrl}`;
      setSupportWhatsappUrl(`https://api.whatsapp.com/send?phone=91${CONTACT_NUMBER.number}&text=${supportMsg}`);
      setDescription(description);
      setImages(data.images);
      setSampleYoutube(data.sampleYoutube);
      const viewNo = Math.floor(Math.random() * (100 - 50 + 1) + 50);
      dispatch(setEventData({
        eventID: data.eventID,
        viewNo: viewNo
      }));
    }
  }, [data]);
  const {
    getCollapseProps,
    getToggleProps
  } = useCollapse({
    collapsedHeight: 110
  });

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const temp = getVisibleRefs(refs);
  //     console.log("temp visible btn", temp);
  //     if (temp.length >= 0 && temp[0] !== "sevas") {
  //       setVisibleBookBtn(true);
  //     } else {
  //       setVisibleBookBtn(false);
  //     }
  //     const currentScrollY = window.scrollY;

  //     setPrevScrollY(currentScrollY);
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [prevScrollY]);

  const scrollToSection = id => {
    const element = refs[id].current;
    if (element) {
      const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
      const yOffset = -120;
      window.scrollTo({
        top: yCoordinate + yOffset,
        behavior: "smooth"
      });
    }
  };
  const getVisibleRefs = refs => {
    return Object.keys(refs).filter(key => {
      const ref = refs[key];
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const height = ref.current.offsetHeight;
        const rectTop = rect.top + height - 400;

        // if (key === "sevas") {
        //   console.log(
        //     "key: " + key,
        //     "top: " + rect.top,
        //     "bottom: " + rect.bottom,
        //     "height: " + height,
        //     "calculated: " + (rect.bottom - rect.top),
        //     "window.innerHeight: " + window.innerHeight,
        //     "rectTop: " + rectTop,
        //     (rectTop >= 0 && rect.bottom <= window.innerHeight) ||
        //       (rectTop < 0 && rect.bottom > window.innerHeight)
        //   );
        // }

        return !bigScreen ? rectTop >= 0 && rect.bottom <= window.innerHeight + height - 200 || rectTop < 0 && rect.bottom > window.innerHeight : rectTop >= 0 && rect.bottom <= window.innerHeight || rectTop >= 0 && rect.bottom > window.innerHeight;
      }
      return false;
    });
  };
  const handleScroll = () => {
    const temp = getVisibleRefs(refs);
    // setVisibleRefs(temp);
    if (temp.length > 0) {
      setActiveLink(temp[0]);
    }
    const scrollDepth = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
    if (temp[0] === "sevas" || scrollDepth > 35 && scrollDepth < 50) {
      setVisibleBookBtn(false);
    } else {
      setVisibleBookBtn(true);
    }
  };

  // Add event listener for scroll event
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [!bigScreen]); // Empty dependency array means this effect runs once on mount and cleanup on unmount

  const handleToRegister = () => {
    // console.log("handleToRegister");

    setDontShowPopup(true);
    const element = refs["sevas"].current;
    if (element) {
      const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
      // const yOffset = -180;
      const yOffset = -120;
      window.scrollTo({
        top: yCoordinate + yOffset,
        behavior: "smooth"
      });
    }
  };
  const handleToReviews = () => {
    const element = refs["review"].current;
    if (element) {
      const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
      const yOffset = 0;
      window.scrollTo({
        top: yCoordinate + yOffset,
        behavior: "smooth"
      });
    }
  };
  const dummyRegistration = async subEventObj => {
    if (!user?.accessToken) {
      setShowLoginModal(true);
      return;
    }
    // let getCookieObj = Cookies.get("eventCookie");
    // if (getCookieObj) {
    //   getCookieObj = JSON.parse(getCookieObj);

    //   Cookies.remove("eventCookie");
    // }

    const res = await eventRegistration({
      eventID: subEventObj.eventID,
      name: user.name,
      contact: user.authID,
      subEventID: subEventObj.subEventID,
      costPrice: subEventObj.pujaCostPrice,
      sellingPrice: subEventObj.eventRegistrationAmount,
      referrerID: userCookieObj?.referrerID || null,
      utm_source: userCookieObj?.utm_source || null,
      utm_medium: userCookieObj?.utm_medium || null,
      utm_campaign: userCookieObj?.utm_campaign || null,
      utm_content: userCookieObj?.utm_content || null,
      source: SMS_TEMPLATE.WEBSITE,
      eventStart: subEventObj.start,
      language: router.locale
    });
    // console.log("Dummy Registration Response", res);
    if (res?.success) {
      if (res?.response?.registrationDetails?.eventRegistrationAmount) {
        dispatch(updatePujaAmount(Number(res?.response?.registrationDetails?.eventRegistrationAmount)));
      } else {
        dispatch(updatePujaAmount(Number(subEventObj?.eventRegistrationAmount)));
      }
      let obj = {
        ...res?.response,
        page: 3
      };
      dispatch(addRegistrationDetails(obj));
      setShowBhetModal(true);
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    let cookieObj = Cookies.get("eventCookie");
    if (cookieObj) {
      cookieObj = JSON.parse(cookieObj);
    } else {
      cookieObj = {
        referrerID: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null
      };
    }
    if (router.query.referrer && user.referralID && user.referralID !== router.query.referrer) {
      cookieObj.referrerID = router.query.referrer;
    } else if (router.query.referrer && user.referralID && user.referralID === router.query.referrer) {
      cookieObj.referrerID = null;
    } else if (router.query.referrer && !user.referralID) {
      cookieObj.referrerID = router.query.referrer;
    }
    if (router.query.utm_source) {
      cookieObj.utm_source = router.query.utm_source;
    }
    if (router.query.utm_medium) {
      cookieObj.utm_medium = router.query.utm_medium;
    }
    if (router.query.utm_campaign) {
      cookieObj.utm_campaign = router.query.utm_campaign;
    }
    if (router.query.utm_content) {
      cookieObj.utm_content = router.query.utm_content;
    }
    Cookies.set("eventCookie", JSON.stringify(cookieObj), {
      expires: 7
    });
    setUserCookieObj(cookieObj);
  }, [router.query]);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!dontShowPopup) setOpenPopupModal(true);
    }, 15000);
    return () => clearTimeout(timer);
  }, [dontShowPopup]);
  return <>
      <div className={style.detailsContainer}>
        <div id="topContainer">
          {/* ---------HEADER BOX--------- */}
          <HeaderPujaDetailsAB data={data} handleToRegister={handleToRegister} handleToReviews={handleToReviews} data-sentry-element="HeaderPujaDetailsAB" data-sentry-source-file="singlePujaViewAB.jsx" />

          {/* ---------NAVv BAR--------- */}
          <div className={style.scrollNavbarContainer}>
            <ScrollNavbarAB scrollToSection={scrollToSection} activeLink={activeLink} setActiveLink={setActiveLink} data={data} data-sentry-element="ScrollNavbarAB" data-sentry-source-file="singlePujaViewAB.jsx" />
          </div>
        </div>

        <div className={style.pujaBottomContainer}>
          {/* ABOUT BOX */}
          <div className={style.pujaSectionContainer} ref={refs.about}>
            <HeadingPuja headline={t("about-puja")} data-sentry-element="HeadingPuja" data-sentry-source-file="singlePujaViewAB.jsx" />

            {showMoreBtn ? <div className={`${style.eDesc} ${style.mobileeDesc}`} {...getCollapseProps()}>
                {ReactHtmlParser(description)}
              </div> : <div className={`${style.eDesc} ${style.mobileeDesc}`}>
                {ReactHtmlParser(description)}
              </div>}

            {showMoreBtn && description && <button className={style.seeMoreBtn} {...getToggleProps({
            onClick: () => {
              if (!seeMore) {
                trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.BUTTON_NAMES.DESCRIPTION_SEE_MORE + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
                  [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
                  [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.DESCRIPTION_SEE_MORE,
                  [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE
                });
              }
              setSeeMore(cur => !cur);
            }
          })}>
                <Typography sx={{
              color: theme.palette.text.primary,
              fontWeight: 500
            }}>
                  {!seeMore ? `${t("show-more")}` : `${t("show-less-0")}`}
                </Typography>
                {!seeMore ? <ExpandMoreIcon /> : <ExpandLessIcon />}
              </button>}
          </div>

          {/* {console.log("showSecondBatch")} */}

          {/* PANDIT CALL BOX */}
          {data.isVerified && !data.isClosed && data.panditAvailability !== PANDIT_AVAILABILITY.OFF && <>
                {!bigScreen && data.panditAvailability === PANDIT_AVAILABILITY.CALL_PANDIT ? <a href={`tel:+91` + data.panditContact}>
                    <div className={style.floatCallingButton}>
                      {/* <CallIcon sx={{ color: "white" }} />
                       <span style={{ color: "white" }}>Talk with Pandit Ji</span> */}

                      <Image src={panditBanner} alt="Pandit Banner" layout="fill" objectFit="cover" />
                    </div>
                  </a> : data.panditAvailability === PANDIT_AVAILABILITY.FORM_FILLUP || bigScreen ? <div className={style.floatCallingButton} onClick={() => {
            trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.ITEM_NAMES.PANDIT_BANNER + " " + WEB_ENGAGE.EVENT_NAMES.ITEM_CLICKED, {
              [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
              [WEB_ENGAGE.EVENT_PROPERTIES.ITEM_NAME]: WEB_ENGAGE.ITEM_NAMES.PANDIT_BANNER,
              [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data?.name_WE || "Unknown Kriya",
              [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: data?.urlExtension
            });
            setOpenTalkToPanditModal(true);
          }}>
                    <Image src={panditBanner} alt="Pandit Banner" layout="fill" objectFit="cover" />
                  </div> : <> </>}
              </>}

          {/* PUJA BOOK STEPS BOX */}
          <div className={style.pujaStepContainer} ref={refs.process}>
            <PujaStep data-sentry-element="PujaStep" data-sentry-source-file="singlePujaViewAB.jsx" />
          </div>

          {/* BENEFITS BOX */}
          <div ref={refs.benefits}>
            {data.EventBenefitRelations.length > 0 && <BenefitsPuja data={data} />}
          </div>

          {/* PUJA LIST BOX */}
          <div ref={refs.sevas} className={style.subEventCategoryContainer}>
            <PujaCategoryListAB data={data} uid={user.uid} dummyRegistration={dummyRegistration} data-sentry-element="PujaCategoryListAB" data-sentry-source-file="singlePujaViewAB.jsx" />
          </div>

          {/* SAMPLE YOUTUBE BOX */}
          {!bigScreen && sampleYoutube ? <div ref={refs.youtubeVideo}>
              <PujaYoutubeVideo videoData={sampleYoutube} data={data} />
            </div> : <></>}

          {/* PUJA REVIEW BOX */}
          <div ref={refs.review}>
            {/* {data.ReviewModels?.length >= 5 ? (
              <PujaReviews
                reviews={data.ReviewModels}
                kriya_name={data.name}
                name_WE={data.name_WE}
              />
             ) : (
              <EventBookedPeople data={data.EventRegistrations} />
             )} */}

            <PujaReviews
          // reviews={getRandomReviews()}
          kriya_name={data.name} name_WE={data.name_WE} data-sentry-element="PujaReviews" data-sentry-source-file="singlePujaViewAB.jsx" />
          </div>

          {/* FAQ BOX */}
          {data.Faqs.length > 0 && <div ref={refs.faq}>
              <FaqPuja data={data} id="faq" />
            </div>}

          {/* HELP SUPPORT BOX */}
          {!bigScreen && <div className={style.pujaSectionContainer}>
              <HeadingPuja headline={t("help-and-support")} />
              <div className={style.supportContent}>
                <Typography>
                  {t("helpline-number")} - {CONTACT_NUMBER.number}
                </Typography>
                <div className={style.supportButton} onClick={() => {
              trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.BUTTON_NAMES.HELPLINE_NUMBER + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
                [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
                [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.HELPLINE_NUMBER,
                [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE
              });
              window.open(supportWhatsappUrl, "_blank");
            }}>
                  <WhatsApp size={33} />
                  <Typography className={style.supportText}>
                    {t("chat-on-whatsapp")}
                  </Typography>
                </div>
              </div>
            </div>}
        </div>

        {data.isVerified && !data.isClosed && !bigScreen && <>
            <div className={style.floatSupportButton} onClick={() => {
          trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.BUTTON_NAMES.HELPLINE_NUMBER + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
            [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.HELPLINE_NUMBER,
            [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE
          });
          window.open(supportWhatsappUrl, "_blank");
        }}>
              <WhatsApp size={33} />
            </div>

            {visibleBookBtn && <div className={style.supportContainer}>
                {data.EventFestivalTimelines.length > 0 && <div className={style.mobileBookButtonContainer}>
                    <PujaRegisterButton data={data} clicked_from={WEB_ENGAGE.CLICKED_FROMS.BOTTOM_BUTTON} handleToRegister={handleToRegister} visibleBookBtn={visibleBookBtn} //visibleBookBtn
            />
                  </div>}
              </div>}
          </>}
      </div>

      {openTalkToPanditModal && <TalkToPanditModal openTalkToPanditModal={openTalkToPanditModal} setOpenTalkToPanditModal={setOpenTalkToPanditModal} isPanditJiAvailable={data.isPanditJiAvailable} name_WE={data.name_WE} />}

      {openPopupModal && data.isVerified && !data.isClosed && <PopupModal deityName={data.PujaGodImage?.PujaGod?.name ?? ""} subEventsCategory={data.CommunitySubEventsAllCategory.length > 0 ? data.CommunitySubEventsAllCategory[0]?.CommunitySubEvents : ""} templeName={data.templeName} eventName={data.name} eventName_WE={data.name_WE} eventUrlExtension={data.urlExtension} setOpenModal={setOpenPopupModal} openModal={openPopupModal} EventFestivalTimelines={data.EventFestivalTimelines} dummyRegistration={dummyRegistration} />}

      {showLoginModal && <RegistrationLogin showLoginModal={showLoginModal} setShowLoginModal={setShowLoginModal} setShowBhetModal={setShowBhetModal} />}
      {showBhetModal && <RegistrationBhet showBhetModal={showBhetModal} setShowBhetModal={setShowBhetModal} />}
    </>;
}
export default PujaDetailsAB;